import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export enum MultiIconCellRendererIconType {
    AngularMaterial = 0,
    SeSvg = 1,
    SeFont = 2
}

interface IMultiIconCellRendererConfig {
    icon: string;
    tooltip?: string;
    iconSize?: string;
    iconType?: MultiIconCellRendererIconType;
    field: string;
    hidden: boolean;
    property: string;
    additionalInfo: string;
    showAdditionalInfo: boolean;
}

type IMultiIconCellRendererParams = ICellRendererParams & { estensa: IMultiIconCellRendererConfig[] };

@Component({
    selector: 'se-multi-icon-cell-renderer',
    templateUrl: './multi-icon-cell-renderer.component.html',
    styleUrls: ['./multi-icon-cell-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiIconCellRendererComponent implements ICellRendererAngularComp {
    config: IMultiIconCellRendererConfig[];
    params: IMultiIconCellRendererParams;
    propertyValue: string[];


    private getPropertyValue(obj1, dataToRetrieve) {
        return dataToRetrieve.split('.').reduce(function (o, k) { return o && o[k]; }, obj1);
    }

    refresh(params: IMultiIconCellRendererParams): boolean {

        this.config = [];
        this.propertyValue = [];
        for (const row of params.estensa) {
            row.hidden = !this.getPropertyValue(params.value, row.field);
            this.propertyValue.push(params.data.getPropertyValue(row.property));

            this.config.push(row);

            if (!row.iconSize) {
                row.iconSize = '16px';
            }
        }
        return false;
    }

    agInit(params: IMultiIconCellRendererParams): void {
        this.params = params;
        this.config = [];
        this.refresh(params);
    }

}
